import React, { Component }    from 'react';

import './main_menu.scss';
import {addPopup, setBurgerState} from "../../../redux/actions";
import {connect} from "react-redux";
import DynamicLink from "../../../components/routing/dynamicLink/dynamicLink";

class MainMenu extends Component {
    
    render() {

        const menuItems = this.props.menu;

        let menu = [];
        if(Object.keys(menuItems).length > 0) {
            for (let key in menuItems) {
                menu.push(
                    <li className="item" key={key}>
                        <DynamicLink data={menuItems[key].link} onClick={this.handleCloseClick}>
                            <span> {menuItems[key].title} </span>
                        </DynamicLink>
                    </li>
                );
            }
        }

        return (
            <nav className="main_menu">
                <ul>
                    { menu }
                </ul>
            </nav>
        )
    }
}


//connect to redux store
const mapStateToProps = store => {
    return {
        menu: store.config.Menu
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setBurgerState: (device) => dispatch(setBurgerState(device)),
        addPopup: (payload) => dispatch(addPopup(payload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(MainMenu);